import { render } from "./AccountOrderDetailsGrid.vue?vue&type=template&id=2a533f3d"
import script from "./AccountOrderDetailsGrid.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__